
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topproducts",
      function () {
        return require("private-next-pages/topproducts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topproducts"])
      });
    }
  